import { toast } from 'react-toastify';

export const showToast = (message, type = 'info', options = {}) => {
  const toastMap = {
    success: toast.success,
    error: toast.error,
    info: toast.info,
    warning: toast.warning,
  };

  const toastFn = toastMap[type] || toast;

  toastFn(message, options);
};
